import { render } from "./BaseInput.vue?vue&type=template&id=ec3a9e64"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"
script.render = render

export default script